import * as React from 'react';
import clsx from 'clsx';
import { Link, NavLink } from 'react-router-dom';
import { useBox } from '../Box';
import { useFlex } from '../Flex';
import { useText } from '../Text';
function Interactive({
  to,
  href,
  type,
  tagName,
  refCallback,
  innerRef,
  activeClassName,
  className: mergeClass,
  ...extraProps
}) {
  const [boxClasses, boxExtra] = useBox(extraProps);
  const [flexClasses, flexExtra] = useFlex(boxExtra);
  const [textClasses, textExtra] = useText(flexExtra);
  const className = clsx(boxClasses, flexClasses, textClasses, mergeClass);
  if ((to || href) && extraProps.disabled) {
    if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
      console.warn("Passing a `disabled` attribute to an anchor element won't have any effect.");
    }
  }
  if (tagName) {
    return /*#__PURE__*/React.createElement(tagName, {
      type,
      href,
      ref: innerRef || refCallback,
      className,
      ...textExtra
    });
  }
  if (to && activeClassName) {
    return /*#__PURE__*/React.createElement(NavLink, {
      to,
      ref: innerRef || refCallback,
      className: ({
        isActive
      }) => clsx(className, isActive && activeClassName),
      ...textExtra
    });
  }
  if (to) {
    return /*#__PURE__*/React.createElement(Link, {
      to,
      ref: innerRef || refCallback,
      className,
      ...textExtra
    });
  }
  if (href) {
    return /*#__PURE__*/React.createElement('a', {
      href,
      ref: innerRef || refCallback,
      className,
      ...textExtra
    });
  }
  return /*#__PURE__*/React.createElement('button', {
    type,
    ref: innerRef || refCallback,
    className,
    ...textExtra
  });
}
export default Interactive;